import { App } from 'vue'
import registerElement from './register-elements'
import registerProperties from './register-properties'
import CommonSearch from '@/components/CommonSearch.vue'
import CommonForm from '@/components/CommonForm.vue'
import CommonTable from '@/components/CommonTable.vue'
import CommonPagination from '@/components/CommonPagination.vue'
export function globalRegister(app: App): void {
  // app.use(registerElement)
  app.use(registerProperties)
  app.component('CommonSearch', CommonSearch)
  app.component('CommonForm', CommonForm)
  app.component('CommonTable', CommonTable)
  app.component('CommonPagination', CommonPagination)
}
